module.exports = __webpack_public_path__ + "static/jumbotron-7f5900925c77401cfa494e57b7d8b442.jpg";